import { Col, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent, memo } from 'react'

import { useFinancingCalculations } from '../../utils/useFinancingCalculations'
import { useToggleState } from '../../utils/useToggleState'
import { BuybackFormFinancingChart } from '../BuybackFormFinancingChart/BuybackFormFinancingChart'
import { BuybackFormFinancingHelp } from '../BuybackFormFinancingHelp/BuybackFormFinancingHelp'
import { BuybackFormFinancingSetting } from '../BuybackFormFinancingSetting/BuybackFormFinancingSetting'
import { BuybackFormFinancingTable } from '../BuybackFormFinancingTable/BuybackFormFinancingTable'
import { BuybackFormTitle } from '../BuybackFormTitle/BuybackFormTitle'
import { Fade } from '../Fade/Fade'

export interface BuybackFormFinancingFragmentProps {
  toggleShow: () => void
}

const gutter: Gutter | [Gutter, Gutter] = [16, 16]

export const BuybackFormFinancingFragment: FunctionComponent<BuybackFormFinancingFragmentProps> =
  memo(props => {
    const financingCalculations = useFinancingCalculations()
    const [showChart, toggleChart] = useToggleState(true)
    const [showTable, toggleTable] = useToggleState(true)
    const [showSettings, toggleSettings] = useToggleState(true)
    const [showHelp, toggleHelp] = useToggleState(false)

    return (
      <>
        <BuybackFormTitle
          title="Ověření dostupnosti financování"
          action={{
            onClose: props.toggleShow,
            help: { active: showHelp, onToggle: toggleHelp },
            chart: { active: showChart, onToggle: toggleChart },
            table: { active: showTable, onToggle: toggleTable },
            settings: { active: showSettings, onToggle: toggleSettings },
          }}
        />
        <Row gutter={gutter} className="mb-8">
          <Fade show={showSettings} unmount={false}>
            <Col span={24}>
              <BuybackFormFinancingSetting />
            </Col>
          </Fade>

          <Fade show={showHelp}>
            <Col span={24}>
              <BuybackFormFinancingHelp show={showHelp} onClose={toggleHelp} />
            </Col>
          </Fade>

          <Col span={24}>
            <Fade show={showTable}>
              <BuybackFormFinancingTable calculations={financingCalculations} />
            </Fade>
          </Col>

          <Col span={24}>
            <Fade show={showChart}>
              <BuybackFormFinancingChart calculations={financingCalculations} />
            </Fade>
          </Col>
        </Row>
      </>
    )
  })
